import style from "./review.module.scss";
export function Splitter() {
  return <span className={style.light}> | </span>;
}
